<template>
    <div>
        <p-modal
            size="lg"
            button-label="Add Line"
            name="glEntryLineModal"
            ref="glEntryLineModal"
            @ok="saveGlEntryLine"
            @cancel.prevent="closeModal"
            @close.prevent="closeModal"
            button-variant="primary"
            :button-busy="isBusy"
            no-close-on-backdrop
            no-close-on-esc
        >
            <template v-slot:default>
                <p-form 
                    ref="glEntryLineForm">
                    <div class="container-fluid content-wrapper">
                        <b-row cols="12">
                            <b-col
                                cols="6"
                            >
                                <p-select
                                    label="GL Code"
                                    data-type="chartOfAccounts"
                                    v-model="chartOfAccountsId"
                                />
                            </b-col>
                            <b-col cols="3">
                                <p-input
                                    label="Entry Reference"
                                    v-model="entryReference"
                                    mode="lazy"
                                    rules="required" />
                            </b-col>
                            <b-col>
                                <p-number
                                    input-type="money"
                                    label="Credit"
                                    v-model="credit"
                                    :disabled="debit"
                                    rules="min_value:0"
                                    left-align />
                            </b-col>
                            <b-col>
                                <p-number
                                    input-type="money"
                                    label="Debit"
                                    v-model="debit"
                                    :disabled="credit"
                                    rules="min_value:0"
                                    left-align />
                            </b-col>
                        </b-row>
                    </div>
                </p-form>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-row>
                    <b-col>
                        <b-button 
                            :is-busy="isBusy"
                            variant="outline-primary"
                            @click="cancel"
                        >Cancel
                        </b-button>
                        <p-button
                            :is-busy="isBusy" 
                            variant="primary" 
                            @click="ok" 
                            class="ms-2"
                        >Add
                        </p-button>
                    </b-col>
                </b-row>
            </template>
        </p-modal>
    </div>
</template>

<script>
export default {
    props: {
        isBusy: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            chartOfAccountsId: 0,
            entryReference: "",
            credit: null,
            debit: null
        }
    },
    methods: {
        saveGlEntryLine: async function () {
            this.$emit('ok', this);
            //this stops a validation error from flashing on save/cancel.
            this.$refs.glEntryLineForm?.$refs?.observer?.resetForm();
            this.clearData();
        },
        clearData() {
            this.chartOfAccountsId = 0,
            this.entryReference = "";
            this.credit = null;
            this.debit = null;
        },
        closeModal() {
            this.clearData();
            //this stops a validation error from flashing on save/cancel.
            this.$refs.glEntryLineForm?.$refs?.observer?.resetForm();
            this.$nextTick(() => {
                    this.$refs.glEntryLineModal.hide();
                });
        }
        
    }
}
</script>
